// Siemens ix-icons (MIT), their "ingestion" glyph: an arrow driven into the
// corner of a box. It reads as pushing something into a container, which is
// exactly what applying a profile to Default does.
//
// Two changes from the source file. The fill is currentColor rather than a baked
// #000000, so the icon takes its button's colour and follows it on hover and
// when disabled. And the artwork's own translate is kept -- the path is authored
// around an offset origin, so dropping it would push the glyph off the viewBox.
//
// fillRule="evenodd" is load-bearing, not decoration: the arrow and the hollow
// of the box are cut out of the same path, and without it the shape fills in
// solid.
export const ApplyToDefaultIcon = (props) => (
  <svg fill="none" height={16} viewBox="0 0 512 512" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="currentColor" fillRule="evenodd" transform="translate(48.915055, 48.915055)">
      <path d="M377.751611,15.0849447 L377.751611,377.751611 L15.0849447,377.751611 L15.0849447,143.084945 L57.7509447,143.084945 L57.7516113,335.084945 L335.084945,335.084945 L335.084945,57.7516113 L143.084945,57.7509447 L143.084945,15.0849447 L377.751611,15.0849447 Z M30.1698893,1.42108547e-14 L228.418,198.248 L228.418278,121.751611 L271.084945,121.751611 L271.084945,271.084945 L121.751611,271.084945 L121.751611,228.418278 L198.248,228.418 L-1.42108547e-14,30.1698893 L30.1698893,1.42108547e-14 Z" />
    </g>
  </svg>
);
